module.exports = __webpack_public_path__ + "static/media/trademark.a478c0ee.svg";